import React from 'react';
import style from './Checkbox.module.css';


const Checkbox = props => {
    if (!props.id)
        return <h4>Missing id</h4>;
        
    return <main className={ style.main }>
        <input
            disabled={ props.disabled }
            value=""
            checked={ props.checked }
            onClick={ props.onClick }
            onChange={ props.onChange }
            type="checkbox"
            name={ props.id }
            id={ props.id }
            />
        <label className={ style.label } style={{ ...props.style }} htmlFor={ props.id }>
            <span />
        </label>    
    </main>
};

export default Checkbox
